import Http from '@/services/http';
import { CoolingStageProperty, TransformerCoolingStage } from 'sigma-mappings';
import coolingStageFieldsDefinitions
  from '@/domain/data/installation/assetInformation/coolingStages/coolingStageFieldsDefinitions';
import translate, { formatNumber } from '@/services/translate';

const urls = {
  coolingStages: assetId => `ativo/${assetId}/transformador/estagiosresfriamento`,
};

/* istanbul ignore next */
function getStage(string) {
  const regExp = /\[(.*?)\]/;
  const matches = regExp.exec(string);
  return matches.length ? matches[1] : null;
}

/* istanbul ignore next */
function getField(data) {
  const fieldArray = data.field.split('.');
  const field = fieldArray[fieldArray.length - 1];
  return coolingStageFieldsDefinitions[field];
}

/* istanbul ignore next */
const error = {
  errorHandling: {
    ignore: errorData => errorData.response.data.codigoMensagem === 'MSIS128',
    responseMessageParams: {
      $MA029: (data) => {
        const returnedField = getField(data);
        if (!returnedField) return null;
        const stage = getStage(data.field);
         const options = {
          minimumFractionDigits: returnedField.precision,
          maximumFractionDigits: returnedField.precision || 0,
        };
        const labelToTranslate = stage ? returnedField.validationLabel : returnedField.label;
        return {
          FaixaInicial: formatNumber(returnedField.min, options),
          FaixaFinal: formatNumber(returnedField.max, options),
          NomeDoCampo: translate(labelToTranslate, { stage }),
        };
      },
      $MA052: (data) => {
        const returnedField = getField(data);
        if (!returnedField) return null;
        const stage = getStage(data.field);
        const labelToTranslate = stage ? returnedField.validationLabel : returnedField.label;
        return {
          0: translate(labelToTranslate, { stage }),
          1: formatNumber(returnedField.precision),
        };
      },
    },
  },
};

export default {

  getCoolingStages(assetId) {
    const http = new Http(error);
    return http
      .get(urls.coolingStages(assetId))
      .then(({ data }) => new TransformerCoolingStage(data));
  },

  putCoolingStages(assetId, payload) {
    const http = new Http(error);
    const mappedPayload = new CoolingStageProperty.MapBack(payload);
    return http
      .put(urls.coolingStages(assetId), mappedPayload)
      .then(({ data }) => data);
  },

};
